import { render, staticRenderFns } from "./CustomerSideMenu.vue?vue&type=template&id=f232cf4a"
import script from "./CustomerSideMenu.vue?vue&type=script&lang=js"
export * from "./CustomerSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f232cf4a')) {
      api.createRecord('f232cf4a', component.options)
    } else {
      api.reload('f232cf4a', component.options)
    }
    module.hot.accept("./CustomerSideMenu.vue?vue&type=template&id=f232cf4a", function () {
      api.rerender('f232cf4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/CustomerSideMenu.vue"
export default component.exports